import Model from "./base/model";

class RiskManager extends Model{
  resourceName() {
    return "risk_managers";
  }

  fields() {
    return {
      social_reason: "",
      cnpj: "",
      fantasy_name:"",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "addresses" },
    };
  }
}

export default new RiskManager();
